import wilsongoh from "../Assets/wilsongoh.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={wilsongoh}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Wilson Wen Bin Goh</h2>
        <br />
        <p className="card-sub-name-style">
          A/Prof, Nanyang Technological University
          <br /> Imperial College London
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Wilson Wen Bin Goh</h2>
            <h3>
              A/Prof, Nanyang Technological University
              <br />
              Imperial College London
            </h3>

            <br />
            <p>
              Dr. Wilson Goh is the Chief Data Scientist and Deputy Director at
              the Centre of AI in Medicine (C-AIM) at Nanyang Technological
              University and a Senior Lecturer (Associate Professor) at Imperial
              College London. He leads the Data Science Research Programme and
              serves as Co-Director of the Centre for Biomedical Informatics
              (CBI).
              <br />
              <br />
              Dr. Goh’s research focuses on leveraging complex multimodal
              clinical datasets to develop and deploy AI solutions within
              hospital environments, with particular emphasis on mental health
              and proteomics. His recent work has expanded into implementation
              science, where he explores data governance issues and investigates
              how clinicians trust and interact with AI systems. Through his
              research, Dr. Goh aims to bridge the gap between basic science, AI
              innovation and integration into healthcare.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
